<template lang="html">
  <div
    v-if="show"
    class="content-tag-chips min-w-0"
  >
    <div
      ref="scroller"
      class="flex flex-nowrap items-center gap-2 overflow-x-auto overscroll-x-contain pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="list"
      aria-label="Теги"
    >
      <NuxtLink
        role="listitem"
        :to="basePath"
        active-class=""
        exact-active-class=""
        class="content-tag-chips__chip inline-flex shrink-0 items-center rounded-md border px-3 py-1.5 text-xs font-medium transition-colors duration-200"
        :class="!activeTag
          ? 'border-primary bg-primary text-inverted'
          : 'border-default bg-default text-muted hover:border-accented hover:text-default'"
      >
        Все
      </NuxtLink>

      <NuxtLink
        v-for="chip in orderedTags"
        :key="chip"
        role="listitem"
        :data-tag="chip"
        :to="{ path: basePath, query: { tag: chip } }"
        active-class=""
        exact-active-class=""
        class="content-tag-chips__chip inline-flex shrink-0 items-center rounded-md border px-3 py-1.5 text-xs font-medium whitespace-nowrap transition-colors duration-200"
        :class="activeTag === chip
          ? 'border-primary bg-primary text-inverted'
          : 'border-default bg-default text-muted hover:border-accented hover:text-default'"
      >
        {{ chip }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  basePath: string
  tags: string[]
  activeTag?: string
}>()

const show = computed(
  () => Boolean(props.activeTag) || props.tags.length > 0,
)

/** Active tag first so it stays near «Все» when the row scrolls. */
const orderedTags = computed(() => {
  const list = [...props.tags]
  const active = props.activeTag
  if (!active) return list
  const index = list.indexOf(active)
  if (index <= 0) return list
  list.splice(index, 1)
  list.unshift(active)
  return list
})

const scroller = useTemplateRef<HTMLElement>('scroller')

watch(
  () => props.activeTag,
  async (tag) => {
    if (!tag) return
    await nextTick()
    const el = scroller.value?.querySelector<HTMLElement>(
      `[data-tag="${CSS.escape(tag)}"]`,
    )
    el?.scrollIntoView({
      inline: 'nearest',
      block: 'nearest',
      behavior: 'smooth',
    })
  },
  { immediate: true },
)
</script>
